import DependencyInjector from '../utils/DependencyInjector';
import { CustomEvents } from '../utils/CustomEvents';
import { match } from '../utils/ResolutionHandler';
import { getFirstFocusable } from "../utils/FocusableElementUtils";
import {on, emit, off, one} from '../utils/EventsBus';



/**
 * Generic web component that expose a render method
 */
export default class Component {

  constructor(htmlEl) {
    this.moduleLoader = new DependencyInjector(); // Use this class to lazy load modules!!
    this.$component = htmlEl;
    this.$customEvents = CustomEvents;
    this.$matchMedia = match;
    this.$on = on;
    this.$emit = emit;
    this.$off = off;
    this.$one = one;
    this.$getFirstFocusable = getFirstFocusable;
  }

  /**
   * Log utility
   * @param logStr
   */
  log(logStr = "") {
    if (logStr != "") {
      let myName = this.constructor.name;
      console.log(`[${myName}] ${logStr}`);
    }
  }

  /**
   * Log utility
   * @param logStr
   */
  warn(logStr = "") {
    if (logStr != "") {
      let myName = this.constructor.name;
      console.warn(`[${myName}] ${logStr}`);
    }
  }

  /*
    Main method that execute the render logic of the component
   */
  render() {
    let myName = this.constructor.name;
    console.log(`[${myName}] Rendering..`);
  }
}
